import styled from "@emotion/styled";

export const FormLabelStyled = styled("div")`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
`;
